import React from "react";
import { ArrowLeft } from "react-feather";

const SubmitForm = () => {
  return (
    <div className="mt-16 px-32">
       <a href="/#"
        className="mb-3 focus:outline-none -ml-3 backButtton flex hover:bg-blue-200 items-center px-4 py-2 rounded-md text-blue-700"
        style={{width:"fit-content"}}
      >
        <ArrowLeft size="16" className="mr-2" />
        <span className="text-sm">Back to Help Center</span>
      </a>
      <h1 className="text-3xl font-bold text-gray-800">Submit your request</h1>
      <div className="my-16 text-gray-600">
        <div className="bg-white rounded-lg overflow-hidden shadow-lg p-10">
          <div className="mb-4">
            <p className="font-medium mb-1 text-gray-900 text-sm">Your name</p>
            <input
              className="appearance-none bg-white block border border-gray-400 focus:border-indigo-500 focus:outline-none leading-normal px-4 py-2 rounded-md shadow-sm text-gray-700 text-sm w-full"
              type="text"
            />
          </div>
          <div className="mb-4">
            <p className="font-medium mb-1 text-gray-900 text-sm">
              Your e-mail address
            </p>
            <input
              className="appearance-none bg-white block border border-gray-400 focus:border-indigo-500 focus:outline-none leading-normal px-4 py-2 rounded-md shadow-sm text-gray-700 text-sm w-full"
              type="email"
            />
          </div>
          <div className="mb-4">
            <p className="font-medium mb-1 text-gray-900 text-sm">
              In a few words, tell us what your enquiry is about
            </p>
            <input
              className="appearance-none bg-white block border border-gray-400 focus:border-indigo-500 focus:outline-none leading-normal px-4 py-2 rounded-md shadow-sm text-gray-700 text-sm w-full"
              type="text"
            />
          </div>
          <div className="mb-4">
            <p className="font-medium mb-1 text-gray-900 text-sm">
            Provide a detailed description
            </p>
            <textarea
              rows="4"
              className="mb-4 appearance-none bg-white  border border-gray-400 focus:border-indigo-500 focus:outline-none leading-normal px-4 py-2 rounded-md shadow-sm text-gray-700 text-sm w-full resize-none"
            ></textarea>
          </div>
          <div className="mt-6 text-center">
          <button className="hover:bg-gray-200 mr-3 px-5 py-3 rounded-md text-gray-900 text-sm">Clear</button>
          <button className="bg-indigo-600  px-5 py-3 rounded-md text-sm text-white">Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmitForm;
